import { useToasts } from "@certn/cascadia";
import { ActionListItem, Loader, Text } from "@certn/cascadia-react";
import { Toggle } from "@certn/cascadia-react/components/inputs/toggle/Toggle";
import { useAPIRequest, usePeopleAPI } from "@certn/legacy-api";
import { useTranslation } from "react-i18next";

export function BetaCommunity() {
  const { t } = useTranslation();
  const request = useAPIRequest();
  const { show } = useToasts();

  const { data, isLoading, mutate, isValidating } = usePeopleAPI(
    "/internal/people/me/preferences/"
  );

  const handleToggle = async (joinedBetaCommunityValue: boolean) => {
    try {
      await request("/internal/people/me/preferences/beta-community/update/", {
        method: "POST",
        body: JSON.stringify({
          joined_beta_community: joinedBetaCommunityValue,
        }),
      });
      mutate(
        data
          ? { ...data, joined_beta_community: joinedBetaCommunityValue }
          : undefined
      );
      show({
        title: joinedBetaCommunityValue
          ? t("Joined Certn beta community")
          : t("Left Certn beta community"),
        type: "info",
      });
    } catch {
      show({
        title: t("Something went wrong, try again"),
        type: "error",
      });
    }
  };

  return (
    <ActionListItem
      displayAccessibility
      title={t("Join Certn's beta community")}
      trailing={
        isValidating ? (
          <Loader type="spinner" size="small" />
        ) : data ? (
          <Toggle
            onChange={handleToggle}
            aria-label={t("Join Certn's beta community")}
            isDisabled={isLoading}
            isSelected={data.joined_beta_community}
            testID="beta-community-preferences"
          />
        ) : undefined
      }
    >
      <Text color="text-weak" style="global/body-secondary">
        {t(
          "Get early access to new features and improvements, and share your feedback about the app. "
        )}
      </Text>
    </ActionListItem>
  );
}
